import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as casesAPI from '@debbie/cortex/dist/api/cases.js';
import { caseVouchersEntity } from '@debbie/cortex/dist/case-vouchers/index.js';
import { casesEntity, ensureCaseLoaded, useCase, } from '@debbie/cortex/dist/cases/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../utils/errors.js';
import Button from './Button.js';
import Checkbox from './Checkbox.js';
import ExclusiveContent from './ExclusiveContent.js';
import MoneyInput from './MoneyInput.js';
const CaseSettings = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const [edits, setEdits] = useState({});
    const disableDebtorPaymentPlan = edits.disableDebtorPaymentPlan ??
        singleCase?.settings?.disableDebtorPaymentPlan ??
        false;
    const disableCalculations = edits.disableCalculations ??
        singleCase?.settings?.disableCalculations ??
        false;
    const costCeilingEnabled = edits.costCeilingEnabled ?? singleCase?.costCeilingEnabled ?? false;
    const costCeilingAmount = 'costCeilingAmount' in edits
        ? (edits.costCeilingAmount ?? null)
        : (singleCase?.costCeilingAmount ?? null);
    const saveSettingsMutation = useMutation(async () => {
        if (singleCase == null) {
            throw new Error('No case loaded');
        }
        const patch = {};
        if (edits.disableDebtorPaymentPlan !== undefined ||
            edits.disableCalculations !== undefined) {
            patch.settings = {
                ...singleCase.settings,
                disableDebtorPaymentPlan,
                disableCalculations,
            };
        }
        if (edits.costCeilingEnabled !== undefined) {
            patch.costCeilingEnabled = edits.costCeilingEnabled;
        }
        if ('costCeilingAmount' in edits) {
            patch.costCeilingAmount = edits.costCeilingAmount;
        }
        await casesAPI.patch(props.caseId, patch);
        q.invalidate([
            ...keys.write.modify(casesEntity, props.caseId),
            ...keys.write.create(caseVouchersEntity),
        ]);
        await ensureCaseLoaded(props.caseId);
    }, {
        onSuccess: () => {
            setEdits({});
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.case);
        },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Checkbox, { checked: disableDebtorPaymentPlan, onChange: (e) => {
                setEdits({ ...edits, disableDebtorPaymentPlan: e.target.checked });
            }, placeholder: lang.cases.caseSettings.disableDebtorPaymentPlan }),
        React.createElement(ExclusiveContent, null,
            React.createElement(Checkbox, { checked: disableCalculations, onChange: (e) => {
                    setEdits({ ...edits, disableCalculations: e.target.checked });
                }, placeholder: 'Slettesag: deaktiver alle beregninger' })),
        React.createElement(Checkbox, { checked: costCeilingEnabled, onChange: (e) => {
                setEdits({ ...edits, costCeilingEnabled: e.target.checked });
            }, placeholder: lang.costCeiling.costCeiling }),
        costCeilingEnabled && (React.createElement(MoneyInput, { allowNull: true, value: costCeilingAmount, onChange: (amount) => setEdits({ ...edits, costCeilingAmount: amount }), placeholder: lang.costCeiling.customAmount })),
        React.createElement(Button, { disabled: singleCase == null || Object.keys(edits).length === 0, onClick: () => saveSettingsMutation.mutate(), loading: saveSettingsMutation.isLoading, style: { marginTop: '10px' } }, lang.misc.save)));
};
export default CaseSettings;
//# sourceMappingURL=CaseSettings.js.map